import { isNumber } from "@sperrdatei/dto/utils";
import { useState } from "react";

import { BlockEventList } from "../../components/block-event-list";

import { BlockCheckResult } from "./block-result";
import { CheckNumberForm } from "./form";
import { FullNumberCheckResult } from "./full-number-result";

import type { NumberCheckResponseSuccessResponse } from "@sperrdatei/dto/types";

export type CheckNumberPageProps = object;

export const CheckNumberPage: React.FC<CheckNumberPageProps> = () => {
  const [searchedNumber, setSearchedNumber] = useState("");
  const [showHelp, setShowHelp] = useState(false);
  const [foundNumber, setFoundNumber] = useState<
    NumberCheckResponseSuccessResponse | null | undefined
  >(undefined);

  return (
    <div className="container ms-0">
      <h3 className="page-caption mb-3">Nummer überprüfen</h3>

      <div className="col-xxl-7 col-xl-7 col-lg-10 col-xs-12 mt-0 p-0">
        <p>
          Hier können Sie prüfen, ob eine Nummer bereits in der Sperrdatei
          eingetragen ist.
        </p>

        <p>
          <i className="bi bi-question-square color-primary"></i>{" "}
          <a
            href="#"
            className="link-dark"
            onClick={() => setShowHelp(!showHelp)}
          >
            Hilfe
          </a>
        </p>
        <div className={showHelp ? "collapse show" : "collapse"}>
          <b>Eingabeformat:</b>
          <ul>
            <li>Vorwahl mit führender Null (ohne Länderkennung 0049)</li>
            <li>Nationale Teilnehmernummer/RNB ohne Trennzeichen</li>
          </ul>
          <b>Beispiele:</b>
          <ul>
            <li>Einzelnummer 04012345678</li>
            <li>
              Rufnummerblock 03012345***
              <br />
              <span className="fs-6 fw-light">
                oder alternativ 017812345xxx
              </span>
            </li>
          </ul>
        </div>
      </div>

      {!foundNumber ? (
        <CheckNumberForm
          setFoundNumber={(number) => setFoundNumber(number)}
          setSearchedNumber={(number) => setSearchedNumber(number)}
        />
      ) : null}

      {foundNumber && isNumber(searchedNumber) ? (
        <FullNumberCheckResult
          number={foundNumber.number}
          searchedNumber={searchedNumber}
        />
      ) : foundNumber && !isNumber(searchedNumber) ? (
        <BlockCheckResult
          numbers={foundNumber.numbers}
          searchedNumber={searchedNumber}
        />
      ) : null}

      {foundNumber?.history && foundNumber?.history.length > 0 ? (
        <>
          {" "}
          <h4 className="mt-4">Historie</h4>
          <div className="col-xxl-7 col-xl-7 col-lg-10 col-xs-12 mt-0 p-0">
            <BlockEventList events={foundNumber?.history ?? []} />
          </div>
        </>
      ) : null}
      {foundNumber ? (
        <button
          type="button"
          className="btn btn-primary mb-3"
          onClick={() => {
            setFoundNumber(undefined);
            setSearchedNumber("");
          }}
        >
          Zurück
        </button>
      ) : null}
    </div>
  );
};
